import { render } from "./Main.vue?vue&type=template&id=2c65a955&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=2c65a955&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kvr\\Documents\\git\\krovyaka_io_source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c65a955"]])

export default __exports__